import React, {  Component } from 'react'
import ReactDOM from 'react-dom/client';
import avtlogo from "./img/avt.png"; 
import Apprt from './App';
//import AdmDashboard from './components/AdminDashboard.js';
import './assets/css/homestyle.css'
import axios from 'axios';
import { removeUserSession, setUserSession,aPIURL,auTHURL } from './utils/common.js';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CDashboard from './components/ClientApplication/CDashboard';
import Modal from './components/LoginModal';
import PriceList from './components/PriceList.js';
import PublicNav from './Shared/PublicNav.js'
import PublicFooter from './Shared/PublicFooter.js'
import $ from 'jquery';
import bvideo from './img/AVT-banner.mp4';


class TermsofUse extends React.Component 
{
  
  
  constructor(props) 
  {
    
    super(props);
    this.state = {
     showLogin: false,    
      message:'',
      logInfo:{
                UserName: "",
                Password: ""
             },
      contactInfo:{
              ContactName: "",
              ContactMobile:"",
              ContactEmail: "",
              ContactMessage:""
          }

    };
     
  }
  

 

  render() 
  {
   
    
     return (
      <>       

<header id="header" class="">
  <div class="container d-flex align-items-center header-center justify-content-between"> 
  <a href="index.html" class="logo"> <img src="../img/avt.png" alt="AVT" class="img-fluid"/> </a>

  

  <ul class="navbar-nav avt-top-menu collapse" id='topMenu'>
        <li class="nav-item"> <a href="index.html">Home</a> </li>
        <li class="nav-item"> <a href="index.html">Pricing</a> </li>
        <li class="nav-item"> <a href="index.html">Contact</a> </li>
        
      </ul>
    <div class="logo-right-list">
    
    <span></span>
    <span></span>
    <span></span>
    
    <span></span>
    </div>
  </div>
</header>
<section class="pricing topsection">
  <div class="container"> 
  <div class="row"><div class="col-lg-5">
  <h1>Terms of Use</h1>
   
    </div></div>
  </div>
</section>




<section>
            <div class="container">
           {/* <h2 class="title2 text-center mb-40">Terms of Use</h2>*/}
                <p style={{textAlign:'justify'}}>Terms and Conditions for using AVT Bharat Website. Thank you for using AVT Bharat (“Website”) Services. These Terms of Use, together with Avaal Technology Solutions India Pvt Ltd Policy (“Terms of Use”), shall apply to the users of the website as and when they visit, browse, access data and place orders, upload or download documents, access, or otherwise use the website.</p>
                <p style={{textAlign:'justify'}}>These Terms of Use only apply to your activities when using the website or its contents. The following General Terms of Use apply to all services rendered between AVT Bharat and Users of this site whether as a consignor, consignee, lorry/ truck (Vehicle) owner or in any other capacity. The AVT Bharat through this website provides a platform that enables consignors, consignees and vehicle owners, transport contractors and agents to meet, approach, compare, place orders, or enter contracts or transactions to make easy and seamless transportation, conveyance, or movement goods from one place to another. Deviations from these conditions are only binding if confirmed in writing and these General Terms of Use will apply to all additional services or revised services.</p>

                <h5>User’s Obligation</h5>

                <p><strong>The users agree not to:</strong></p>

                <p>Use the services to obtain unauthorized access to the services, systems, network or data.</p>
                <p>Violate any applicable laws or regulations.</p>
                <p style={{textAlign:'justify'}}>Make available any content that you do not have the right to make available or that infringes any patent, trademark, copyright or other proprietary rights of any person or entity.</p>
                <p style={{textAlign:'justify'}}>Make available viruses or any other computer code, files, programs or content designed to interrupt destroy or limit the functionality of the services and affect other users.</p>
                <p>Interfere with or disrupt the services or servers, systems or networks connected to the services in any way.</p>

                <h5>Confidentiality</h5>

                <p style={{textAlign:'justify'}}>The AVT Bharat website shall in no event be liable for any direct, indirect, special, consequential or other damages arising out of the use of this website or any information or images contained therein, including without limitation, lost profits, business interruption and loss of programs or other data. Each party is obliged to treat any data and information not publicly accessible as confidential and to use these exclusively for the purpose intended.</p>


                <p>The confidentiality rule does not apply to data and information that must be passed on to third parties, especially public authorities, due to legal obligations. The other party is to be informed about such obligation without delay.</p>

                <h5>Limitation of Liability and Warranties</h5>
                <p><strong>The AVT Bharat Website:</strong></p>

                <p>Shall not take responsibility or liability for the pricing and payment terms of contract entered between Vehicle owner and consignor/consignee, transport contractors and agents using this website as a platform.</p>
                <p>Shall not take responsibility or liability for any dispute arising between consignor or consignee or vehicle owner (or Lorry provider) or driver regarding quantity, quality, packing, assembling, etc. of goods conveyed with the help of this website.</p>
                <p>Shall be harmless from all claims, losses, damages, and liabilities, costs, and expenses, including without limitation legal fees and expenses, arising out of or related to use or misuse of the services or of the website, any violation by user of these Terms of Use, or any breach of the representations, warranties, and covenants made herein.</p>
                <p>Shall not be liable for any late pickup, late delivery, early arrival, early delivery any waiting charges and also if user procure the freight without pickup service and/or delivery service, they themselves are responsible for delivering the shipment to the designated drop-off and/or pickup point.</p>
                <p>Shall not be responsible for goods or services or the terms on which services may be procured or availed using this website as a platform. If the user chooses to procure or avail such goods or services, user should carefully evaluate them and the terms upon which you are availing them.</p>
                <p>Shall not be responsible for any natural loss, damage, deterioration of goods involved including on account of pilferage, theft, accident, natural calamity, or any other similar cause.</p>
                <p>Shall not be liable for any conduct of the drivers of the vehicles. Users may notify complaints against the driver of any vehicle that you may have hired using this platform.</p>
                <p>Shall not be liable for performance of service as earlier agreed by user parties.</p>
                <p>Shall penalize the load owner, by charging a cancellation fee, if he/she refuses to load the shipment when lorry owner reaches the destination as specified by load owner, when the load owner had booked for the service and had paid the advance to AVT Bharat.</p>
                <p>May ask you for feedback of listed vehicles users from whom the users would have availed services.</p>
                <p>Shall withhold the user’s money in case the user is engaged in any fraudulent or malicious behavior on the platform; and</p>
                <p>May contact the user, in any way, in case money is credited to user’s account due to any technical glitch caused by AVT Bharat and the user shall credit the exact amount transferred by AVT Bharat within 10 (ten) days of such request by AVT Bharat. In case the user does not credit the amount within the prescribed time as mentioned in this clause, AVT Bharat shall have the right to approach the court against the user.</p>
                <p>The user of the website acknowledges and agrees that they shall be liable for checking the contents, packing, sealing, addressing, labeling, and handling of the goods, carriage, shipping instruction or waybill.</p>

                <h5>Intellectual Property</h5>

                <p>The AVT Bharat name and logo, and other trademarks, service marks, graphics and logos used in connection with the website are trademarks of Avaal Technology Solutions India Pvt Ltd. Other trademarks, service marks, graphics and logos used in connection with the website are the trademarks of their respective owners (collectively “Third Party Trademarks”). The AVT Bharat Trademarks and Third-Party Trademarks may not be copied, imitated, or used, in whole or in part, without the prior written permission of the applicable trademark holder.</p>

                <h5>Indemnity and limitation of liability</h5>

                <p>In case any loss or damage occurs to us due to your failure to provide us the correct information, or due to your engagement in any such activity on our platform, which may be in violation of the applicable law in India, you shall indemnify us from such damage or loss.</p>
                <p>You shall be bound by the Terms of Use, and shall be liable to indemnify us wholly, if you breach any provision of the Terms of Use. You agree that we shall not be liable for any illegal or offensive conduct of any third party on our platform. Further, we shall not be liable for any delay or inaccuracy in information provided by any third party on our platform.</p>
                <p>Any dealing between you and the third-party, on or through our platform, including the delivery of product or service, payment, conditions etc., shall be between you and the third-party only. We shall not be liable for any damage or loss pertaining to such dealings.</p>

                <h5>General law and Jurisdiction</h5>

                <p>Except as otherwise set forth in these Terms, these Terms shall be governed by Indian laws and the parties submit to the exclusive jurisdiction of Indian courts to resolve any dispute between them arising under or in connection with these website Terms.</p>

                <p>If any provision (or part of a provision) of these website Terms is found by any court or administrative body of competent jurisdiction to be invalid, unenforceable, or illegal, such term, condition or provision will to that extent be severed from the remaining terms, conditions and provisions which will continue to be valid to the fullest extent permitted by law. reserved to trademark holder and its licensors.</p>

                <p style={{textAlign:'justify'}}>Any dispute, conflict, claim, or controversy arising out of or broadly in connection with or relating to the Services or these Terms, including those relating to its validity, its construction or its enforceability (any “Dispute”) shall be first mandatorily submitted to mediation proceedings in terms of the Indian law. If such Dispute has not been settled within sixty (60) days after a request for mediation has been submitted under the Indian laws, such Dispute can be referred to and shall be exclusively and finally resolved by arbitration under the Arbitration and Conciliation Act, 1996 (“Act”). The Dispute shall be resolved by one (1) arbitrator to be appointed by Avaal Technology Solutions Inc. The place of both mediation and arbitration shall be Gurgaon, Haryana, India. The language of the mediation and/or arbitration shall be English, unless you do not speak English, in which case the mediation and/or arbitration shall be conducted in both English and your native language. The existence and content of the mediation and arbitration proceedings, including documents and briefs submitted by the parties, any correspondence from the mediator, and correspondence, orders and awards issued by the sole arbitrator, shall remain strictly confidential and shall not be disclosed to any third party without the express written consent from the other party unless: (i) the disclosure to the third party is reasonably required in the context of conducting the mediation or arbitration proceedings; and (ii) the third party agrees unconditionally in writing to be bound by the confidentiality obligation stipulated herein.</p>

                <h5>Amendment to the Terms of Use</h5>

                <p style={{textAlign:'justify'}}>We may amend or alter the Terms of Use from time to time. Any changes to these Terms of Use shall become effective upon posting of the revised Terms of Use on the platform, and no communication of such alteration, amendment or update shall be made to you. It is recommended that you regularly check these Terms of Use to apprise yourself of any updates.</p>

                <h5>Miscellaneous</h5>

                <p>The Terms of Use shall not create any partnership or agency between you and us.</p>
                <p style={{textAlign:'justify'}}>Each obligation is separate from the other obligations of these Terms of Use. If one or more of the obligations contained in these Terms of Use is held invalid, illegal, or unenforceable in any respect by any court of competent jurisdiction, such holding will not impair the validity, legality, or enforceability of the remaining obligations.</p>
                <p>Time is of utmost importance for all the matters relating to the Terms of Use.</p>
                <p>The time when you access the platform, the Terms of Use shall stand duly executed between you and us.</p>


            </div>
        </section>

<PublicFooter/>
<Modal isOpen={this.state.showLogin} >
            <div class="modal-header justify-content-center bg-white border-0">
                <h5 className='modal-title'>Login</h5>
                <button type="button" class="btn-close" onClick={this.closeLoginModal}></button>
                </div>
                <div class="modal-body">
            
                <div class="row">
            <div className="" >
             <div className="form-group"> User Name
                  <input id="UserName" autofocus="autofocus"  name="UserName" type="text" required="required" className="form-control" onChange={this.changeHandler} onKeyDown={this.handleUsernameKeyDown}></input>
              </div>
              <div className="form-group"> Password
                  <input id="Password" name="Password" type="text" required="required" className="form-control customer-password"  onChange={this.changeHandler} onKeyDown={this.handlePasswordKeyDown}></input>
              </div>
              <div className="text-center">
                <button type="submit" name="signin" id="signin" onClick={this.onClickLogin} className="btn btn-primary2 w-100 mt-2">Login</button>
                <p>{this.state.message}</p><br></br><br></br>
              </div>
          </div>
            </div>
            </div>
             
            </Modal>
            <ToastContainer position="bottom-right" autoClose={4000} theme="light"/>
    </>
      
    );
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<TermsofUse/>);


export default TermsofUse;